import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Employee Activity Monitor',
		url: '/changes',
		icon: 'user',
	},
	{
		name: 'Firearm Trace Log',
		url: '/changes/firearm_traces',
		icon: 'fa fa-arrows-alt',
	},
];

export default class Firearm_Traces extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Collections.FirearmTraceLogs
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

			</div>
		);
	}
}